import React from 'react';
import { useTranslation } from 'react-i18next';
import { WarningModal } from '@/components/Ad/WarningModal';
import { usePaymentStatusModalStore } from '@/store/usePaymentStatusModalStore';

export function InvoicePaymentSuccessModal() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = usePaymentStatusModalStore(state => [
    state.isInvoicePaymentSuccessModalOpen,
    state.setIsInvoicePaymentSuccessModalOpen,
  ]);

  function handleClose() {
    setIsOpen(false);
  }

  return (
    <WarningModal
      dataTestId="invoice-payment-success-modal"
      description=""
      icon="check-circle-rounded.svg"
      isOpen={isOpen}
      onClose={handleClose}
      title={t('pages.cabinet.package_invoice_paid_successfully')}
    />
  );
}
